module.exports = __webpack_public_path__ + "6be2b385f739fec62954a9e82ba3d773.png";